import { normalizeCompanyMemberRole } from "@/lib/company-member-roles";

type CrewUserLike = {
  companyId?: string | null;
  role?: string | null;
  scafferAccountKind?: string | null;
};

/** Client-safe crew detection (matches lib/crew/workspace.ts). */
export function isCompanyCrewUserClient(user: CrewUserLike | null | undefined): boolean {
  if (!user?.companyId) return false;
  if (user.scafferAccountKind === "operative") return false;
  return normalizeCompanyMemberRole(user.role ?? "") === "scaff";
}
